import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import roadmapImage from '../../../assets/images/roadmap-logo.png';

const certificates = [
  {
    title: 'Data Analyst',
    issuedBy: 'One Roadmap',
    date: '11 August 2025',
    image: roadmapImage,
    link: 'https://drive.google.com/file/d/1aIetS8ET54kwBJUO34oUjb1EnFlL1YZM/view?usp=drive_link'
  }
];

const OneRoadmapCertificate = () => {
  return (
    <CertificateDetailTemplate
      provider="One Roadmap"
      certificates={certificates}
    />
  );
};

export default OneRoadmapCertificate;
